export const addressValidationMessage = 'Billing Address not found, please enter a valid address'
